import React from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../../../../ReduxToolkit/Store';
import { Card, CardBody, Col, TabContent, TabPane } from 'reactstrap';
import HeaderCard from './Common/HeaderCard';
import { Business, CreatedByMe, Favourites, Holidays, Important, MyBookmark, Newsletter, Notification, Organization, SharedWithMe } from '../../../../Utils/Constants';
import EmptyCard from './Common/EmptyCard';
import DataLoop from './DataLoop';
import FavDataLoop from './FavDataLoop';
import EditBookmarkModal from '../BookmarkModals/EditBookmarkModal';

export default function RightAsideBookmark() {
    const { activeTabs, gridView } = useSelector((state: RootState) => state.bookmark);

    return (
        <Col xl={9} md={12} className="box-col-12">
            <div className="email-right-aside bookmark-tabcontent">
                <Card className="email-body radius-left">
                    <div className="ps-0">
                        <TabContent activeTab={activeTabs}>
                            <TabPane tabId={'1'}>
                                <Card className="mb-0">
                                    <HeaderCard title={CreatedByMe}/>
                                    <CardBody className="pb-0">
                                        <div className={`details-bookmark text-center ${!gridView ? 'list-bookmark' : ''}`}>
                                            <DataLoop />
                                        </div>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId={'2'}>
                                <Card className='mb-0'>
                                    <HeaderCard title={Favourites} />
                                    <CardBody>
                                        <div className={`details-bookmark text-center ${!gridView ? 'list-bookmark' : ''}`}>
                                            <FavDataLoop />
                                        </div>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId={'3'}><EmptyCard title={SharedWithMe} /></TabPane>
                            <TabPane tabId={'4'}>
                                <Card className="mb-0">
                                    <HeaderCard title={MyBookmark} />
                                    <CardBody>
                                        <div className={`details-bookmark text-center ${!gridView ? 'list-bookmark' : ''}`}>
                                            <DataLoop />
                                        </div>
                                    </CardBody>
                                </Card>
                            </TabPane>
                            <TabPane tabId={'5'}><EmptyCard title={Notification} /></TabPane>
                            <TabPane tabId={'6'}><EmptyCard title={Newsletter} /></TabPane>
                            <TabPane tabId={'7'}><EmptyCard title={Business} /></TabPane>
                            <TabPane tabId={'8'}><EmptyCard title={Holidays} /></TabPane>
                            <TabPane tabId={'9'}><EmptyCard title={Important} /></TabPane>
                            <TabPane tabId={'10'}><EmptyCard title={Organization} /></TabPane>
                            <EditBookmarkModal />
                        </TabContent>
                    </div>
                </Card>
            </div>
        </Col>
    )
}